import React from 'react';

import MobileModalForm from '../../../../components/Form/MobileModalForm';
import * as fieldNames from '../../../../consts/form/formInputNames';
import * as localizationKeys from '../../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../../services/localization/localizationService';

const DataCollectorMobileForm = ({modalType, formFields, ...props}) => {
    const localizedStrings = getLocalizedStrings();

    return (
        <MobileModalForm
            {...props}
            formName={`data-collector-mobile-${modalType}`}
            className='data-collector-mobile-form'
            closeLabel={localizedStrings[localizationKeys.DC_PAGE_MOBILE_CLOSE_FORM]}
            formFields={formFields.map((field) => ({
                ...field,
                autoComplete: field.name === fieldNames.PASSWORD ? 'new-password' : undefined,
                inputMode: field.name === fieldNames.SIM_NUMBER ? 'tel' : undefined,
            }))}
        />
    );
};

export default DataCollectorMobileForm;
